    // @ts-nocheck

    import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
    import { fetchMeetingEvents, addMeetingEvent, updateMeetingEvent } from "../../api/meetingEvent";

    // Async thunks for meetingEvent operations

    export const getMeetingEvents = createAsyncThunk(
    "meetingEvent/getMeetingEvents",
    async (_, { dispatch, rejectWithValue }) => {
        dispatch(resetStatus());

        try {
        return await fetchMeetingEvents();
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );

    export const createMeetingEvent = createAsyncThunk(
    "meetingEvent/createMeetingEvent",
    async (
        newMeetingEvent: { title: string; description: string; date: string; time: string; is_active: boolean; location?: string },
        { dispatch, rejectWithValue }
    ) => {
        dispatch(resetStatus());

        try {
        return await addMeetingEvent(newMeetingEvent);
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );

    export const editMeetingEvent = createAsyncThunk(
    "meetingEvent/editMeetingEvent",
    async (
        { updatedMeetingEvent }: { updatedMeetingEvent: { id: string; title: string; description: string; date: string; time: string; is_active: boolean; location?: string } },
        { dispatch, rejectWithValue }
    ) => {
        dispatch(resetStatus());

        try {
        return await updateMeetingEvent(updatedMeetingEvent);
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );

    // MeetingEvent Slice

    const meetingEventSlice = createSlice({
    name: "meetingEvent",
    initialState: {
        meetingEvents: [] as any[],
        status: null as boolean | null,
        msg: "",
        error: null as string | null,
    },
    reducers: {
        resetStatus(state) {
        state.status = null;
        state.msg = "";
        },
    },
    extraReducers: (builder) => {
        builder
        // Get all meeting events
        .addCase(getMeetingEvents.fulfilled, (state, action: PayloadAction<any[]>) => {
            state.status = true;
            state.meetingEvents = action.payload;
        })
        .addCase(getMeetingEvents.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        })

        // Create meeting event
        .addCase(createMeetingEvent.fulfilled, (state, action: PayloadAction<any>) => {
            if (Array.isArray(state.meetingEvents)) {
            state.meetingEvents.push(action.payload);
            state.status = true;
            state.msg = "Meeting event created successfully.";
            } else {
            console.log("meetingEvents not an array");
            }
        })
        .addCase(createMeetingEvent.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        })

        // Edit meeting event
        .addCase(editMeetingEvent.fulfilled, (state, action: PayloadAction<any>) => {
            const { id, data } = action.payload;
            if (Array.isArray(state.meetingEvents)) {
            const index = state.meetingEvents.findIndex((event) => event.id === id);
            if (index !== -1) {
                state.meetingEvents[index] = data;
            }
            state.status = true;
            state.msg = "Meeting event updated successfully.";
            } else {
            console.log("meetingEvents not an array");
            }
        })
        .addCase(editMeetingEvent.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        });
    },
    });

    export const { resetStatus } = meetingEventSlice.actions;
    export default meetingEventSlice.reducer;
